var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "viewMods lgrid-noGutter" },
      _vm._l(_vm.enabledButtons, function (viewModId, key) {
        return _c("button", {
          key: key,
          staticClass: "no-button lgrid-middle-noWrap",
          class: [viewModId, viewModId == _vm.currentMod ? "active" : ""],
          domProps: { innerHTML: _vm._s(_vm.t.viewMods[viewModId]) },
          on: {
            click: function ($event) {
              _vm.currentMod = viewModId
            },
          },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }